import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.83681 5.688H11.6128V7.392H6.83681V12.336H5.10881V7.392H0.332813V5.688H5.10881V0.719999H6.83681V5.688Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(Svg);
export { ForwardRef as ReactComponent };
